export const lippincott = [
	{
		"id": 1,
		"jump": "lippincott",
		"title": "",
		"pic": "../img/lippincott/iphone-display.jpg",
		"alt": "iPhone screens of Chris Lippincott on Spotify",
		"center": "splash-img"
	},
	{
		"id": 2,
		"jump": "lippincott1",
		"title": "'Open Sketches'",
		"desc": "Digital Album Art",
		"pic": "../img/lippincott/open-sketches.jpg",
		"alt": "Open Sketches', Digital Album Art",
		"center": "imagewide"
	},
	{
		"id": 3,
		"jump": "lippincott2",
		"title": "'Fall To Rise'",
		"desc": "Digital Single Art",
		"pic": "../img/lippincott/fall-to-rise.jpg",
		"alt": "Fall To Rise, Digital Single Art",
		"center": "imagewide"
		
	},
	{
		"id": 4,
		"jump": "lippincott3",
		"title": "'Undertow'",
		"desc": "Digital Single Art",
		"pic": "../img/lippincott/undertow.jpg",
		"alt": "Undertow, Digital Single Art",
		"center": "imagewide"
		
	},
		{
		"id": 4,
		"jump": "lippincott4",
		"title": "'Unfolding'",
		"desc": "Digital Single Art",
		"pic": "../img/lippincott/unfolding.jpg",
		"alt": "Unfolding, Digital Single Art",
		"center": "imagewide"
		
	},
]